import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://8569a50981b9f75a93f8c76817bd409a@o4508633941868544.ingest.us.sentry.io/4508633942196224',
  environment: import.meta.env.PROD ? 'production' : 'local',
  integrations: [Sentry.replayIntegration()],
  enabled: import.meta.env.PROD,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  // tracesSampleRate: 1.0,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  // replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
